import { apolloProvider as myStageApolloProvider } from '@/modules/myStageGraphQL';
import { STORE_TRAINERTAG_MSB } from '@/graphql/Mystage/trainerTag';
import { bizmatesWordbookApi } from '@/utils/bizmatesApi';
import qs from 'qs';

import logger from '@/modules/Logger';

export const StoreTrainerTagService = {
  // Method to store trainer tags and update from new GraphQL endpoint
    msb: async (params, callback) => {
    logger.debug(`[Store TrainerTag] Store trainer tags from MSB GraphQL endpoint`, {
      operation: 'tag:store_trainer_tag'
    });
    params.forEach(obj => {
      delete obj.tags;
    });

    const client = myStageApolloProvider.defaultClient;
    const { data } = await client.mutate({
      mutation: STORE_TRAINERTAG_MSB,
      fetchPolicy: 'no-cache',
      variables: {
        tags: params
      }
    });

    if (data?.storeTrainerTags) {
      callback(data.storeTrainerTags);
      return data.storeTrainerTags;
    } else {
      logger.error(`[Store TrainerTag] Empty result from store GraphQL API`, {
        event_type: 4,
      });
    }
  },

  // Method to  store trainer tags and update from legacy REST API endpoint
  legacy: async (params, callback) => {
    logger.debug(`[Store TrainerTag] Saving using legacy REST API`, {
      operation: 'tag:store_trainer_tag'
    });

    try {
      let responseData;
      const stringifyData = qs.stringify({ data: params }, { strictNullHandling: true });
      await bizmatesWordbookApi.post('trainertag', stringifyData, {}, response => {
        responseData = response.data.data;
        callback(responseData);
        return responseData;
      });

      return responseData;
    } catch (error) {
      logger.error(`[Store TrainerTag] Error saving tags`, {
        error
      });
      throw error;
    }
  }
};
